module.exports = __webpack_public_path__ + "static/media/as_item4_bg.358f9fbc.png";